<template>
    <div class="hello">
        <h1>{{ title }}</h1>

        <router-link to="/teams" tag="button" v-if="all && !loading" type="button">
            <i class="fas fa-random"></i>
            <span class="button-text">Zu den Teams wechseln</span>
        </router-link>

        <div class="spacer-small"></div>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="users">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th class="kgk-left">Benutzername</th>
                        <th class="kgk-center">Stadt</th>
                        <th class="kgk-center">Firma</th>
                        <th class="kgk-center">Team</th>
                        <th style="white-space:nowrap"># Läufe</th>
                        <th>Gelaufene Kilometer</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in users"
                        :key="user.identifier">
                        <td>
                            <div v-if="user.competitive" class="kgk-mobile-th">Platzierung:</div>
                            <span v-if="user.competitive" class="kgk-ranking-num">{{ index + 1 }}.</span>
                        </td>
                        <td style="padding-top:8px;padding-bottom:8px;">
                            <a class="kgk-avatar kgk-avatar--list" v-if="user.avatar_url" :href="user.avatar_url" @click.prevent="" v-kgk-avatar="user.avatar_url"></a>
                            <div class="kgk-avatar kgk-avatar--list" v-else v-kgk-avatar="user.avatar_url"></div>
                        </td>
                        <td class="kgk-left">
                            <div class="kgk-mobile-th">Benutzername:</div>
                            {{ user.username }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Stadt:</div>
                            {{ user.city }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Firma:</div>
                            {{ user.company || '&ndash;' }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Team:</div>
                            {{ user.team_name || '&ndash;' }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Anzahl Läufe:</div>
                            {{ user.run_count }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Kilometer:</div>
                            <strong>{{ Math.round(user.total_length) }} km</strong>
                        </td>
                    </tr>
                </tbody>
            </table>

            <router-link to="/users" tag="button" v-if="!all && !loading" type="button">
                <i class="fas fa-user fa-fw"></i>
                <span class="button-text">Alle Läufer anzeigen</span>
            </router-link>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import leaderboard from '../../api/leaderboard';

    export default {
        name: 'LeaderboardUsers',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Topliste Läufer',
            },
            all: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                users: null,
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true;

            leaderboard.getUsers(
                this,
                this.all,
                data => this.users = data.users,
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>

<style scoped>
    /* Buttons are inline-block by default, so they'd otherwise inherit
       text-align:left from ancestors that left-align the leaderboard table
       (e.g. Wettbewerb.vue's .kgk-wettbewerb-leaderboard) -- center them
       independent of that. */
    button {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
